import { IonCard, IonImg } from '@ionic/react';

import { mergeClassNames } from '@/utils';

import GaitObservationsIllustration from '@/assets/illustrations/GaitObservationsIllustration.svg';
import HamstringAnalysisIllustration from '@/assets/illustrations/HamstringAnalysisIllustration.svg';
import KneeStabilityIllustration from '@/assets/illustrations/KneeStabilityIllustration.svg';

import styles from './SessionTypeCard.module.css';

interface SessionTypeCardProps {
  type: 'GO' | 'ACL' | 'Hamstring';
  selected: boolean;
  onSelect: (type: string) => void;
}

export const SessionTypeCard = ({ type, selected, onSelect }: SessionTypeCardProps) => {
  return (
    <>
      <IonCard
        className={mergeClassNames(styles.card, selected ? styles.selected : '')}
        id={type}
        onClick={() => onSelect(type)}>
        <IonImg
          className={styles.illustration}
          src={
            {
              GO: GaitObservationsIllustration,
              ACL: KneeStabilityIllustration,
              Hamstring: HamstringAnalysisIllustration,
            }[type]
          }
        />

        <div className={styles.text}>
          {type === 'GO' && 'Gait Observations'}
          {type === 'ACL' && 'ACL Recovery Tool'}
          {type === 'Hamstring' && 'Hamstring Analysis'}
        </div>
      </IonCard>
    </>
  );
};
